(function () {
  var STORAGE_KEY = 'bylanette:favorites';
  var EVENT = 'bylanette:favorites:changed';
  var MONEY_FORMAT = window.ShopifyMoneyFormat || '€{{amount_with_comma_separator}}';

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      window.dispatchEvent(new CustomEvent(EVENT, { detail: { handles: list } }));
    } catch (e) {}
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    write(list);
    return list.indexOf(handle) !== -1;
  }

  function remove(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i !== -1) {
      list.splice(i, 1);
      write(list);
    }
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€ ' + amount;
  }

  function syncButtons() {
    document.querySelectorAll('[data-favorite-button]').forEach(function (btn) {
      var handle = btn.getAttribute('data-favorite-button');
      var active = has(handle);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('is-active', active);
      var label = active
        ? (btn.getAttribute('data-label-active') || 'Verwijderen uit favorieten')
        : (btn.getAttribute('data-label') || 'Toevoegen aan favorieten');
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    });
  }

  function updateCount() {
    var count = read().length;
    document.querySelectorAll('[data-favorites-count]').forEach(function (el) {
      var vorig = parseInt(el.textContent, 10) || 0;
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      // Zelfde korte pop als de winkelmand-badge: een favoriet toevoegen
      // verdient dezelfde bevestiging bovenin. Test op het data-attribuut,
      // niet op een CSS-klasse.
      if (count > vorig && el.hasAttribute('data-count-pop')) {
        el.classList.remove('is-bumped');
        void el.offsetWidth; // reflow forceren zodat de animatie opnieuw start
        el.classList.add('is-bumped');
      }
    });
  }

  function bind() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-favorite-button]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-favorite-button');
      if (!handle) return;
      toggle(handle);
    });

    window.addEventListener(EVENT, function () {
      syncButtons();
      updateCount();
      var page = document.querySelector('[data-favorites-page]');
      if (page) renderPage(page);
    });
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (attrs[k] == null) return;
        if (k === 'class') node.className = attrs[k];
        else node.setAttribute(k, attrs[k]);
      });
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (c == null) return;
        node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return node;
  }

  function buildHeartSvg() {
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'currentColor');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.4');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(svgNS, 'path');
    path.setAttribute('d', 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z');
    svg.appendChild(path);
    return svg;
  }

  function buildCard(product) {
    var media = el('div', { class: 'product-card__media' });
    if (product.featured_image) {
      media.appendChild(el('img', {
        src: product.featured_image,
        alt: product.title || '',
        loading: 'lazy',
        decoding: 'async',
        class: 'product-card__image'
      }));
    }
    if (product.available === false) {
      media.appendChild(el('span', { class: 'product-card__badge' }, 'Uitverkocht'));
    }

    var mediaLink = el('a', { href: product.url, class: 'product-card__media-link' }, media);

    var info = el('div', { class: 'product-card__info' });
    if (product.type) {
      info.appendChild(el('span', { class: 'product-card__type' }, product.type));
    }
    info.appendChild(el('a', { href: product.url, class: 'product-card__name' }, product.title));
    info.appendChild(el('p', { class: 'product-card__price' }, formatMoney(product.price)));

    var btn = el('button', {
      type: 'button',
      class: 'favorite-button favorite-button--card is-active',
      'data-favorite-button': product.handle,
      'aria-pressed': 'true',
      'aria-label': 'Verwijderen uit favorieten',
      title: 'Verwijderen uit favorieten'
    });
    btn.appendChild(buildHeartSvg());

    var card = el('article', {
      class: 'product-card',
      'data-product-card': '',
      'data-product-handle': product.handle
    }, [mediaLink, info, btn]);

    return card;
  }

  function renderPage(root) {
    var grid = root.querySelector('[data-favorites-grid]');
    var empty = root.querySelector('[data-favorites-empty]');
    var loading = root.querySelector('[data-favorites-loading]');
    var list = read();

    if (!grid) return;

    if (list.length === 0) {
      grid.replaceChildren();
      if (loading) loading.setAttribute('hidden', '');
      if (empty) empty.removeAttribute('hidden');
      return;
    }

    if (empty) empty.setAttribute('hidden', '');
    if (loading) loading.removeAttribute('hidden');

    Promise.all(list.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) {
          if (r.ok) return r.json();
          // Alleen een echte 404 betekent dat het product weg is. Een 429/5xx of
          // netwerkfout is tijdelijk: dan de favoriet NIET wissen, alleen overslaan.
          return { __missing: r.status === 404 };
        })
        .catch(function () { return { __missing: false }; });
    })).then(function (products) {
      if (loading) loading.setAttribute('hidden', '');

      var fragment = document.createDocumentFragment();
      products.forEach(function (p, i) {
        if (!p || p.__missing !== undefined) {
          if (p && p.__missing) remove(list[i]);
          return;
        }
        fragment.appendChild(buildCard(p));
      });

      grid.replaceChildren(fragment);

      if (grid.children.length === 0) {
        if (empty) empty.removeAttribute('hidden');
      }
    });
  }

  function init() {
    bind();
    syncButtons();
    updateCount();
    var page = document.querySelector('[data-favorites-page]');
    if (page) renderPage(page);
  }

  window.ByLanetteFavorites = {
    read: read,
    has: has,
    toggle: toggle,
    remove: remove,
    sync: function () { syncButtons(); updateCount(); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
